import { useEffect } from "react";
import { toastService } from "../utils/helpers/toastService";
import { SetURLSearchParams } from "react-router-dom";
import { IncidentStatus } from "../types/fieldInstance.interface";
const useModeLock = ({
  canUserEditPostSubmission,
  editModeActive,
  setSearchParams,
  incidentStatus,
}: {
  canUserEditPostSubmission: boolean;
  editModeActive: boolean;
  setSearchParams: SetURLSearchParams;
  incidentStatus: IncidentStatus | undefined;
}) => {
  useEffect(() => {
    const shouldEditModeRevert =
      !canUserEditPostSubmission && incidentStatus !== IncidentStatus.Open;
    if (shouldEditModeRevert && editModeActive) {
      setSearchParams({ mode: "view" }); // Revert to view mode if user lacks permissions
      toastService.error("You do not have permission to edit this form.");
    }
  }, [canUserEditPostSubmission, editModeActive, incidentStatus]);
};

export default useModeLock;
